import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';

import { AuthService } from './auth.service';

export const customerAuthGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  // Wait for the initial cookie-based session check instead of reading isAuthenticated()
  // synchronously -- on a fresh bootstrap (hard reload, direct link) that signal starts false
  // until the check resolves, so reading it immediately would wrongly redirect an already
  // logged-in shopper to /auth.
  return auth.ensureAuthChecked().pipe(
    map((authenticated) =>
      authenticated ? true : router.createUrlTree(['/auth'], { queryParams: { returnUrl: state.url } }),
    ),
  );
};

